import { CLEAR_HEADER_SEARCH, SET_HEADER_SEARCH, CREDIT_MODAL, AUTH_MODAL } from '../types/header.type'

export const updateSearchAction = (value, clear) => async (dispatch) => {
  if (clear) dispatch({ type: CLEAR_HEADER_SEARCH })
  setTimeout(() => {
    dispatch({ type: SET_HEADER_SEARCH, payload: value })
  }, 100)
}

export const toggleAuthModal = (visible) => (dispatch) => dispatch({ type: AUTH_MODAL, payload: visible })

export const creditModal = (val) => (dispatch) => {
  dispatch({
    type: CREDIT_MODAL,
    payload: {
      enableAddonModal: val,
    },
  })
}
